import { render, staticRenderFns } from "./form-block.vue?vue&type=template&id=cc312082&scoped=true"
import script from "./form-block.ts?vue&type=script&lang=ts&external"
export * from "./form-block.ts?vue&type=script&lang=ts&external"
import style0 from "./form-block.vue?vue&type=style&index=0&id=cc312082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc312082",
  null
  
)

export default component.exports